import { useState } from 'react';

import { Button } from '@oui/app-core/src/components/Button';
import { SliderInput } from '@oui/app-core/src/components/SliderInput';
import { Lead, Text } from '@oui/app-core/src/components/Text';
import { View } from '@oui/app-core/src/components/View';

/**
 * Allows user to select a distress rating for the previous round.
 */
export const DistressRatingForm = ({ onSubmit }: { onSubmit: (rating: number) => unknown }) => {
  const [value, setValue] = useState(5);
  return (
    <View testID="DistressRatingForm" style={{ gap: 50 }}>
      <Text
        text="Please answer the following question."
        textAlign="center"
        style={{ paddingBottom: 75 }}
      />
      <Lead text="How intense was your distress during this round?" textAlign="center" />
      <View>
        <SliderInput
          aria-label="How intense was your distress during this round?"
          minValue={1}
          minLabel="No distress"
          maxValue={10}
          maxLabel="Max distress"
          value={value}
          onChangeValue={setValue}
          displayStyle="both"
        />
      </View>
      <Button text="Next" variant="contained" onPress={() => onSubmit(value)} alignSelf="center" />
    </View>
  );
};
